import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "checkmark-circle-outline-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { stroke: "currentColor", strokeWidth: 1.5, fill: "none", fillRule: "evenodd" },
        React.createElement("circle", { cx: 8, cy: 8, r: 6.25 }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M5.5 8.5l1.5 2 3.5-5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
